export const initialState = {
  termAndConditions: [],
  termAndCondition: {},
  publishTermAndConditionPage: {},
  termConditionBanner: {},
  adminTermConditionBanner: {}
};
